<template>
  <FloatLabel variant="on" class="chat-widget__music-tags chat-widget__w-100">
    <div class="chat-widget__music-tags-wrapper">
      <div class="chat-widget__music-tags-input-wrapper">
        <InputText
            type="text"
            class="chat-widget__music-tags-input"
            inputId="on_music_tags"
            v-model="userInput.musicTags"
            :placeholder="isLabelFloating ? placeholderText : ''"
            @focus="handleFocus"
            @blur="handleBlur"
        />
        <i v-if="userInput.musicTags"
           class="pi pi-times chat-widget--cursor-pointer chat-widget__music-tags--clear"
           @click="clearInput"/>
      </div>
      <i class="pi pi-info-circle chat-widget--cursor-pointer"
         v-tooltip.bottom="'Стиль, укажите через запятую (например, винтажный джаз-лаундж, классические стандарты, плавные соло на трубе, контрабас и знойный женский вокал)'"/>
    </div>
    <label for="on_music_tags">Стиль (через запятую, опционально)</label>
  </FloatLabel>
</template>

<script setup>
import {ref} from 'vue';
import InputText from 'primevue/inputtext';
import FloatLabel from "primevue/floatlabel";
import {useInputStore} from '@/modules/chat/stores/userInputStore';

const userInput = useInputStore();
const isLabelFloating = ref(false);
const placeholderText = "Например, винтажный джаз-лаундж, классические стандарты, плавные соло на трубе, контрабас и знойный женский вокал";

const handleFocus = () => {
  setTimeout(() => {
    isLabelFloating.value = true;
  }, 50); // задержка
};

const handleBlur = () => {
  if (!userInput.musicTags) {
    isLabelFloating.value = false;
  }
};

const clearInput = () => {
  userInput.musicTags = '';
  isLabelFloating.value = false;
};
</script>
